import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import routeConstant from "./routeConstant";
import { IsLogin } from "../../../src/utils";

function ProtectedRoutes(props) {
  const location = useLocation();

  if (IsLogin()) {
    return props.children;
  }

  if (location.pathname === routeConstant.SCHEDULE) {
    return <Navigate replace to={routeConstant.SCHEDULE_LOGIN} />;
  }
  return <Navigate replace to={routeConstant.LOGIN} />;
}

export default ProtectedRoutes;
